import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader  from '@material-ui/core/CardHeader';
import CardContent  from '@material-ui/core/CardContent';
import CardActions  from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';
import DialogCourse from './DialogCourse';
import Grid from '@material-ui/core/Grid';

import EditIcon from '@material-ui/icons//Edit';

import LocationOnIcon from '@material-ui/icons//LocationOn';

import ExpandMoreIcon from '@material-ui/icons//ExpandMore';
import Hidden from '@material-ui/core/Hidden';

import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import store from '../store';
import firebase from "firebase/app";
import "firebase/firestore";
import { phone, callWait } from '../config/static';
import  FormControl  from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import moment from 'moment'
import _ from 'lodash'
const styles = theme => ({
    actions: {
        display: 'flex',
        padding: theme.spacing.unit * 2
    },
    avatar: {
        backgroundColor: red[500],
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    }
})
function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}

let _this;
class CardCourse extends React.Component {
    constructor() {
        super();
        this.state = { expanded: false, open: false,openAssign:false,search: '',
        checked: [] };
        _this = this;
    }
    handleExpandClick = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    handleOpen = () => {
        this.setState({
            open: !this.state.open,
        });
    }







    handleClose = value => {
        this.setState({ open: false });
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };



    render() {

        const { classes, item } = this.props;

        //const ACCOUNT = store.getState().ACCOUNT;
        var subheader = (<span>Start:{item.startDate} - End:{item.startDate}<br/>{"Week: "+item.week} - {"Ignore Day Check: "+(item.nodaycheck&&item.nodaycheck==1?'YES':'NO')}</span>);


        return (
            <div>
                <Card key={item.id} style={{ marginBottom: 20 }}>
                    <CardHeader
                        avatar={<AllInboxIcon/>}
                        action={
                            <div style={{ marginTop: 6 }}>
                                <Hidden xsDown>
                                    <IconButton aria-label="Edit" onClick={this.handleOpen} style={{ backgroundColor: '#eee', color: '#555', marginRight: 12 }}>
                                        <EditIcon />
                                    </IconButton>
                                    </Hidden></div>}
                        title={item.name}
                        subheader={subheader}
                    />
                    <Hidden smUp>
                        <CardActions className={classes.actions} disableActionSpacing>


                            <IconButton aria-label="Edit" onClick={this.handleOpen} style={{ backgroundColor: '#eee', color: '#555', marginRight: 12 }}>
                                <EditIcon />
                            </IconButton>

                        </CardActions>
                    </Hidden>


                </Card>
                {this.state.open ? <DialogCourse
                    item={item}
                    cats={this.props.cats}
                    fullScreen={true}
                    open={this.state.open}
                    onClose={this.handleClose}
                /> : ''}
            </div>
        )
    }
}

CardCourse.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardCourse);
